import React from "react";
import styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";

import { GameStatusContext } from "../../providers/GameStatus";

function WordButton({ word, fullCandidateSize }) {
    const { guessCandidate, setGuessCandidate } =
        React.useContext(GameStatusContext);
    const [isSelected, setIsSelected] = React.useState(
        !!guessCandidate.includes(word)
    );

    const isCandidateListFull = guessCandidate.length === fullCandidateSize;

    React.useEffect(() => {
        setIsSelected(!!guessCandidate.includes(word));
    }, [guessCandidate, word]);

    function flipSelection() {
        if (isSelected) {
            // remove from candidateGuess
            const updatedGuessCandidate = guessCandidate.filter((w) => {
                return w !== word;
            });
            setGuessCandidate(updatedGuessCandidate);
            // set state to *not* selected
            setIsSelected(false);
        } else {
            // check if the candidate array is full
            if (!isCandidateListFull) {
                // add to candidateGuess array
                setGuessCandidate([...guessCandidate, word]);
                // set state to *selected*
                setIsSelected(true);
            }
        }
    }

    const isMultiWord = word.trim().includes(" ");
    const isVeryLongWord = word.length >= 12;
    const isLongWord = word.length >= 9;

    let textSizeClass;
    if (isVeryLongWord && !isMultiWord) {
        textSizeClass = "text-[7px] sm:text-[10px] md:text-sm lg:text-base";
    } else if (isLongWord) {
        textSizeClass = "text-[8px] sm:text-xs md:text-sm lg:text-base";
    } else {
        textSizeClass = "text-[10px] sm:text-sm md:text-base lg:text-lg";
    }

    // If single word, force one line (nowrap). If multi-word, allow wrapping (normal).
    const wrapClass = isMultiWord ? "whitespace-normal" : "whitespace-nowrap";

    return (
        <Toggle
            className={`${styles.growShrink} select-none h-14 sm:h-16 md:h-20 w-full px-1 sm:px-2 md:px-3`}
            variant="outline"
            pressed={isSelected}
            onClick={flipSelection}
        >
            <p
                className={`${textSizeClass} font-bold leading-tight text-center w-full ${wrapClass}`}
            >
                {word}
            </p>
        </Toggle>
    );
}

export default WordButton;
